export default {
    "html": {
        "type": "html",
        "icon": "fa-file-word",
        "title": "Rich Text",
        "public":true,
        "config": {
            "html": ""
        }
    },
    "map-widget": {
        "type": "map-widget",
        "icon": "fa-map-marker",
        "title": "Map",
        "config": {
            "markers": [],
            "colors": [],
            "height": 500,
            "pitch": 30,
            "zoom": 16,
            "centerLon": 114.1584,
            "centerLat": 22.282225
        }
    },
    "heatmap-widget": {
        "type": "heatmap-widget",
        "icon": "fa-map",
        "title": "Heatmap",
        "config": {
            "height": 500,
            "width": 500,
            "min": 0,
            "max": 100,
            "agg": "D",
            "aggOpp": "mean",
            "imageUrl": null,
            "options": {
                "radius": 150,
                "blur": 1,
                "maxOpacity": 0.8
            },
            "points": []
        }
    },
    "correlation-widget": {
        "type": "correlation-widget",
        "icon": "fa-th",
        "title": "Correlation",
        "config": {},
        "public":true,
        "configInterface":{
            "title":"Correlation",
            "args":[
                {
                    "type":"equipment_name",
                    "name": "equipmentName"
                }
            ]
        }
    },
    "fdd-breakdown-widget": {
        "type": "fdd-breakdown-widget",
        "title": "FDD Breakdown",
        "icon": "fa-bell",
        "config": {
            "colorway":"#1f77b4,#ff7f0e,#2ca02c,#d62728,#9467bd,#8c564b,#e377c2,#7f7f7f,#bcbd22,#17becf",
            "criticalColor":"rgb(148, 103, 189)",
            "highColor":"rgb(214, 39, 40)",
            "mediumColor":"rgb(255, 127, 14)",
            "lowColor":"rgb(188, 189, 34)",
            "title1":"Fault severity",
            "title2":"Fault breakdown",
        },
        "public":true,
        "configInterface":{
            "title":"FDD Breakdown",
            "args":[
                {
                    "type":"boolean",
                    "name": "vertical",
                    "label":"Vertical Layout"
                },
                {
                    "type":"boolean",
                    "name": "hideTable",
                    "label":"Hide Table"
                },{
                    "type":"boolean",
                    "name": "groupMode",
                    "label":"Group Issues"
                },
                {
                    "type":"color",
                    "name": "criticalColor",
                    "label":"Critical Color"
                },
                {
                    "type":"color",
                    "name": "highColor",
                    "label":"High Color"
                },
                {
                    "type":"color",
                    "name": "mediumColor",
                    "label":"Medium Color"
                },
                {
                    "type":"color",
                    "name": "lowColor",
                    "label":"Low Color"
                },
                {
                    "type":"string",
                    "name": "colorway",
                    "label":"Colorway"
                },
                {
                    "type":"string",
                    "name": "title1",
                    "label":"Pie Title"
                },
                {
                    "type":"string",
                    "name": "title2",
                    "label":"Breakdown Title"
                },
                {
                    "type":"number",
                    "name": "labelMargin",
                    "label":"Label Margin Override"
                }
            ]
        }
    },
    "notif-breakdown-widget": {
        "type": "notif-breakdown-widget",
        "title": "Notification Facet",
        "icon": "fa-bell",
        "config": {
            "height":300,
            "limit":10,
            "facet":"equipment_type"
        },
        "public":true,
        "configInterface":{
            "title":"Notification Facet",
            "args":[
                {
                    "type":"string",
                    "name": "title",
                    "label":"Title"
                },
                {
                    "type":"selector",
                    "name": "facet",
                    "label":"Facet",
                    "multiple":false,
                    "required":true,
                    "items":[
                        "equipment_name",
                        "severity",
                        "equipment_type",
                        "title",
                        "topic",
                    ]
                },
                {
                    "type":"number",
                    "name": "limit",
                    "label":"Limit"
                },
                {
                    "type":"number",
                    "name": "height",
                    "label":"Height"
                },
            ]
        }
    },
    "forge-viewer-widget": {
        "type": "forge-viewer-widget",
        "title": "3D Viewer",
        "icon": "fa-cube",
        "config": {
            "height":600
        },
        "configInterface":{
            "title":"3D Viewer",
            "args":[
                {
                    "type":"string",
                    "name": "url",
                    "label":"A360 Embed URL"
                },
                {
                    "type":"number",
                    "name": "height",
                    "label":"Height"
                },
                {
                    "type":"number",
                    "name": "selectedItemID",
                    "label":"Selected Item ID"
                },
                {
                    "type":"string",
                    "name": "selectionColor",
                    "label":"Selection Color"
                }
            ]
        }
    },
    "forge-viewer-heatmap-widget": {
        "type": "forge-viewer-heatmap-widget",
        "title": "3D Heatmap",
        "icon": "fa-cube",
        "config": {
            "height": 600,
            "agg": "D",
            "aggOpp": "mean",
            "points": []
        },
    },
    "fault-eval-widget": {
        "type": "fault-eval-widget",
        "title": "Fault Evaluation",
        "icon": "fa-bell",
        "config": {},
        "configInterface":{
            "title":"Fault Evaluation",
            "args":[
                {
                    "type":"string",
                    "name": "title",
                    "label":"Title"
                },
                {
                    "type":"string",
                    "name": "rule",
                    "label":"Rule",
                    "required":true
                },
                {
                    "type":"string",
                    "name": "value",
                    "label":"Value"
                },
                {
                    "type":"string",
                    "name": "cost",
                    "label":"Cost"
                },
                {
                    "type":"string",
                    "name": "relevantVariables",
                    "label":"Relevant Variables"
                },
                {
                    "type":"equipment_name",
                    "name": "equipmentName",
                    "required":true
                },
                {
                    "type":"radio",
                    "name": "onOnly",
                    "required":true,
                    "items":[
                        {
                            "label":"Rule Active when Equipment On",
                            "value":true,
                            "color":"green",
                        },{
                            "label":"Rule Active when Equipment Off",
                            "value":false,
                            "color":"yellow",
                        },{
                            "label":"Rule Active Anytime",
                            "value":null
                        }
                    ]
                },
                {
                    "type":"boolean",
                    "name": "showCost",
                    "label":"Show Cost"
                },
            ]
        }
    },
    // "staging-profile-widget": {
    //     "type": "staging-profile-widget",
    //     "title": "Staging Profile",
    //     "icon": "fa-history",
    //     "config": {
    //         "title": "Chiller Staging",
    //         "yTitle": "COP",
    //         "xTitle": "Cooling Load (kW)"
    //     },
    //     "configInterface":{
    //         "title":"Staging Profile",
    //         "args":[
    //             {
    //                 "type":"string",
    //                 "name": "title",
    //                 "label":"Title"
    //             },
    //             {
    //                 "type":"string",
    //                 "name": "xTitle",
    //                 "label":"X Axis Title"
    //             },
    //             {
    //                 "type":"string",
    //                 "name": "yTitle",
    //                 "label":"Y Axis Title"
    //             }
    //         ]
    //     }
    // },
    // "cooling-load-forecast-widget": {
    //     "type": "cooling-load-forecast-widget",
    //     "title": "Cooling Load Forecast",
    //     "icon": "fa-chart-line",
    //     "config": {
    //         "title": "Latest Cooling Load Forecast",
    //         "yTitle": "Cooling Load (kWh)",
    //         "xTitle": "Time",
    //         "expectedValueLegend": "Expected Value",
    //         "fittedValueLegend": "Fitted Value",
    //         "actualObservedValueLegend": "Actual Observed Value",
    //         "confidenceIntervalLegend": "95% Confidence Interval",
    //         "daysBefore":14
    //     },
    //     "configInterface":{
    //         "title":"Cooling Load Forecast",
    //         "args":[
    //             {
    //                 "type":"string",
    //                 "name": "title",
    //                 "label":"Title"
    //             },
    //             {
    //                 "type":"string",
    //                 "name": "xTitle",
    //                 "label":"X Axis Title"
    //             },
    //             {
    //                 "type":"string",
    //                 "name": "yTitle",
    //                 "label":"Y Axis Title"
    //             },
    //             {
    //                 "type":"string",
    //                 "name": "expectedValueLegend",
    //                 "label":"Expected Value Line Name"
    //             },
    //             {
    //                 "type":"string",
    //                 "name": "fittedValueLegend",
    //                 "label":"Fitted Value Line Name"
    //             },
    //             {
    //                 "type":"string",
    //                 "name": "actualObservedValueLegend",
    //                 "label":"Actual Observed Value Line Name"
    //             },
    //             {
    //                 "type":"string",
    //                 "name": "confidenceIntervalLegend",
    //                 "label":"Confidence Interval Name"
    //             },
    //             {
    //                 "type":"string",
    //                 "name": "resultName",
    //                 "label":"Custom Result Name"
    //             },
    //             {
    //                 "type":"number",
    //                 "name": "daysBefore",
    //                 "label":"Days Before Range"
    //             }
    //         ]
    //     }
    // },
    // "chiller-sequencing-fla-widget": {
    //     "type": "chiller-sequencing-fla-widget",
    //     "title": "Chiller Sequencing FLA",
    //     "icon": "fa-bolt",
    //     "config": {
    //         "title": "Chiller Sequencing Profile - % of FLA",
    //         "xTitle": "% of FLA",
    //         "yTitle": "Building Cooling Load (kW)"
    //     },
    //     "configInterface":{
    //         "title":"Chiller Sequencing FLA",
    //         "args":[
    //             {
    //                 "type":"string",
    //                 "name": "title",
    //                 "label":"Title"
    //             },
    //             {
    //                 "type":"string",
    //                 "name": "xTitle",
    //                 "label":"X Axis Title"
    //             },
    //             {
    //                 "type":"string",
    //                 "name": "yTitle",
    //                 "label":"Y Axis Title"
    //             }
    //         ]
    //     }
    // },
    // "chiller-sequencing-delta-widget": {
    //     "type": "chiller-sequencing-delta-widget",
    //     "title": "Chiller Sequencing Delta",
    //     "icon": "fa-caret-up",
    //     "config": {
    //         "title": "Chiller Sequencing Profile - DTchw",
    //         "xTitle": "Building Cooling Load (kW)",
    //         "yTitle": "Temperature Δ (°C)"
    //     },
    //     "configInterface":{
    //         "title":"Chiller Sequencing Delta",
    //         "args":[
    //             {
    //                 "type":"string",
    //                 "name": "title",
    //                 "label":"Title"
    //             },
    //             {
    //                 "type":"string",
    //                 "name": "xTitle",
    //                 "label":"X Axis Title"
    //             },
    //             {
    //                 "type":"string",
    //                 "name": "yTitle",
    //                 "label":"Y Axis Title"
    //             }
    //         ]
    //     }
    // },
    // "cooling-load-vs-oat-widget": {
    //     "type": 'cooling-load-vs-oat-widget',
    //     "title": "Cooling Load vs OAT",
    //     "icon": "fa-thermometer-empty",
    //     "config": {
    //         "title": 'Cooling Load VS Outdoor Temperature',
    //         "xTitle": 'Outdoor Temperature (°C)',
    //         "yTitle": 'Cooling Load (kW)'
    //     },
    //     "configInterface":{
    //         "title":"Cooling Load vs OAT",
    //         "args":[
    //             {
    //                 "type":"string",
    //                 "name": "title",
    //                 "label":"Title"
    //             },
    //             {
    //                 "type":"string",
    //                 "name": "xTitle",
    //                 "label":"X Axis Title"
    //             },
    //             {
    //                 "type":"string",
    //                 "name": "yTitle",
    //                 "label":"Y Axis Title"
    //             }
    //         ]
    //     }
    // },
    "optimization-widget": {
        "type": "optimization-widget",
        "title": "Optimization",
        "icon": "fa-piggy-bank",
        "config": {
            "customInterpolation": null,
            "interpolation": "linear",
            "powerSensor": "Power",
            "weatherSensor": "Weather - Outdoor_Temperature",
            "weatherTitle": "Average outdoor air temperature (°C)",
            "title": "Energy consumption vs OAT",
            "weatherAgg": "mean",
            "startDate": null,
            "endDate": null,
            "cutOff": null,
            "useSwitch": false,
            "switchSensor": "Header - Switch_Optimization",
            "minTemp": 20,
            "maxTemp": 35,
            "minPower": 0,
            "maxPower": 1000000000,
            "aggFrequency": null
        }
    },
    "flexible-optimization-widget": {
        "type": "flexible-optimization-widget",
        "title": "Custom Optimization",
        "icon": "fa-piggy-bank",
        "config": {
            "customInterpolation": null,
            "span":0.6,
            "band":0.8,
            "degree":1,
            "interpolation": "linear",
            "powerSensor": "Power",
            "weatherSensor": "Weather - Outdoor_Temperature",
            "weatherTitle": "Average outdoor air temperature (°C)",
            "title": "Energy consumption vs OAT",
            "startDate": null,
            "endDate": null,
            "cutOff": null,
            "useSwitch": false,
            "switchSensor": "Header - Switch_Optimization",
            "minTemp": 20,
            "maxTemp": 35,
            "data3query": {
                "layout-overrides": {
                    "title": "",
                    "showlegend": false,
                    "height": 300,
                    "margin": {
                        "l": 50,
                        "r": 50,
                        "b": 0,
                        "t": 0,
                        "pad": 1
                    },
                    "xaxis": {
                        "title": ""
                    },
                    "yaxis": {
                        "title": ""
                    },
                    "zaxis": {
                        "title": null
                    }
                },
                "x-axis": "timestamp",
                "y-axis": null,
                "independent-x": false,
                "color-axis": null,
                "marker-size-axis": null,
                "color-axis-scale": null,
                "color-axis-title": null,
                "data-payload": [
                    {
                        "filters": {
                            "sensor_name": "Power"
                        },
                        "seriesOverrides": {
                            "type": "table",
                            "opacity": 1,
                            "xbins": {
                                "size": 1
                            },
                            "ybins": {
                                "size": 1
                            }
                        },
                        "pipeline": [
                            {
                                "type": "agg_h",
                                "agg_op": "sum",
                                "name": "Power"
                            }
                        ],
                        "offsetRange": false,
                        "offsetType": "months",
                        "offsetAmount": 1
                    },
                    {
                        "filters": {
                            "sensor_name": "Outdoor_Temperature",
                            "equipment_name": "Weather"
                        },
                        "seriesOverrides": {
                            "type": "table",
                            "opacity": 1,
                            "xbins": {
                                "size": 1
                            },
                            "ybins": {
                                "size": 1
                            }
                        },
                        "pipeline": [],
                        "offsetRange": false,
                        "offsetType": "months",
                        "offsetAmount": 1
                    }
                ]
            }
        }
    },
    "flexible-cop-savings-widget": {
        "type": "flexible-cop-savings-widget",
        "title": "Custom COP Savings",
        "icon": "fa-piggy-bank",
        "config": {
            "customInterpolation": null,
            "interpolation": "linear",
            "powerSensor": "Power",
            "coolingLoadSensor": "Cooling_Load",
            "title": "COP Improvement",
            "startDate": null,
            "endDate": null,
            "cutOff": null,
            "useSwitch": false,
            "switchSensor": "Header - Switch_Optimization",
            "showMeanCop": true,
            "data3query": {
                "layout-overrides": {
                    "title": "",
                    "showlegend": false,
                    "height": 300,
                    "margin": {
                        "l": 50,
                        "r": 50,
                        "b": 0,
                        "t": 0,
                        "pad": 1
                    },
                    "xaxis": {
                        "title": ""
                    },
                    "yaxis": {
                        "title": ""
                    },
                    "zaxis": {
                        "title": null
                    }
                },
                "x-axis": "timestamp",
                "y-axis": null,
                "independent-x": false,
                "color-axis": null,
                "marker-size-axis": null,
                "color-axis-scale": null,
                "color-axis-title": null,
                "data-payload": [
                    {
                        "filters": {
                            "sensor_name": "Power"
                        },
                        "seriesOverrides": {
                            "type": "table",
                            "opacity": 1,
                            "xbins": {
                                "size": 1
                            },
                            "ybins": {
                                "size": 1
                            }
                        },
                        "pipeline": [
                            {
                                "type": "agg_h",
                                "agg_op": "sum",
                                "name": "Power"
                            }
                        ],
                        "offsetRange": false,
                        "offsetType": "months",
                        "offsetAmount": 1
                    },{
                        "filters": {
                            "sensor_name": "Cooling_Load"
                        },
                        "seriesOverrides": {
                            "type": "table",
                            "opacity": 1,
                            "xbins": {
                                "size": 1
                            },
                            "ybins": {
                                "size": 1
                            }
                        },
                        "pipeline": [
                            {
                                "type": "agg_h",
                                "agg_op": "sum",
                                "name": "Cooling_Load"
                            }
                        ],
                        "offsetRange": false,
                        "offsetType": "months",
                        "offsetAmount": 1
                    },

                ]
            }
        }
    },
    "cop-savings-widget": {
        "type": "cop-savings-widget",
        "title": "COP Improvement",
        "icon": "fa-piggy-bank",
        "config": {
            "customInterpolation": null,
            "interpolation": "linear",
            "powerSensor": "Chiller_Plant_Chiller_Header - Total_Plant_Power",
            "coolingLoadSensor": "Chiller_Plant_Chiller_Header - Total_Plant_Cooling_Load",
            "title": "COP Improvement",
            "startDate": null,
            "endDate": null,
            "cutOff": null,
            "useSwitch": false,
            "switchSensor": "Header - Switch_Optimization",
            "minCoolingLoad": 0,
            "maxCoolingLoad": 1000000000,
            "minPower": 0,
            "maxPower": 1000000000,
            "minFilter": 0,
            "maxFilter": 1000000000,
            "useFilter": false,
            "filterSensor": "Weather - Outdoor_Temperature",
            "aggFrequency": null,
            "showMeanCop": true
        }
    },
    // "bms-widget": {
    //     "type": 'bms-widget',
    //     "title": "BMS",
    //     "icon": "fa-thermometer-empty",
    //     "config": {
    //         "title": 'BMS',
    //         "svg":""
    //     },
    // },
    "svg-widget": {
        "type": 'svg-widget',
        "title": "Custom",
        "icon": "fa-cogs",
        "config": {
            "svg":""
        },
    },
    "code": {
        "type": "code",
        "icon": "fa-code",
        "title": "HTML Code",
        "config": {
            "html": ""
        }
    },
    "custom-ec-widget": {
        "type": "custom-ec-widget",
        "icon": "fa-code",
        "title": "Custom EC",
        "config": {
            "processorFunction": "(data,echarts)=>{return null}",
            "height":300,
            "timer":5,
            "animationMode":false,
            "data3query": {
                "layout-overrides": {
                    "title": "",
                    "showlegend": false,
                    "height": 300,
                    "margin": {
                        "l": 50,
                        "r": 50,
                        "b": 0,
                        "t": 0,
                        "pad": 1
                    },
                    "xaxis": {
                        "title": ""
                    },
                    "yaxis": {
                        "title": ""
                    },
                    "zaxis": {
                        "title": null
                    }
                },
                "x-axis": "timestamp",
                "y-axis": null,
                "independent-x": false,
                "color-axis": null,
                "marker-size-axis": null,
                "color-axis-scale": null,
                "color-axis-title": null,
                "data-payload": [
                    {
                        "filters": {
                            "sensor_name": "Power"
                        },
                        "seriesOverrides": {
                            "type": "table",
                            "opacity": 1,
                            "xbins": {
                                "size": 1
                            },
                            "ybins": {
                                "size": 1
                            }
                        },
                        "pipeline": [
                            {
                                "type": "agg_h",
                                "agg_op": "sum",
                                "name": "Power"
                            }
                        ],
                        "offsetRange": false,
                        "offsetType": "months",
                        "offsetAmount": 1
                    }
                ]
            }
        }
    },
    "data-export-widget": {
        "type": "data-export-widget",
        "icon": "fa-download",
        "title": "Data Export",
        "config": {
            "title": "Export Data",
            "fileName": "CSV Export",
            "includeRangeInName":false,
            "data3query": {
                "layout-overrides": {
                    "title": "",
                    "showlegend": false,
                    "height": 300,
                    "margin": {
                        "l": 50,
                        "r": 50,
                        "b": 0,
                        "t": 0,
                        "pad": 1
                    },
                    "xaxis": {
                        "title": ""
                    },
                    "yaxis": {
                        "title": ""
                    },
                    "zaxis": {
                        "title": null
                    }
                },
                "x-axis": "timestamp",
                "y-axis": null,
                "independent-x": false,
                "color-axis": null,
                "marker-size-axis": null,
                "color-axis-scale": null,
                "color-axis-title": null,
                "data-payload": [
                    {
                        "filters": {
                            "sensor_name": "Power"
                        },
                        "seriesOverrides": {
                            "type": "table",
                            "opacity": 1,
                            "xbins": {
                                "size": 1
                            },
                            "ybins": {
                                "size": 1
                            }
                        },
                        "pipeline": [
                            {
                                "type": "agg_h",
                                "agg_op": "sum",
                                "name": "Power"
                            }
                        ],
                        "offsetRange": false,
                        "offsetType": "months",
                        "offsetAmount": 1
                    }
                ]
            }
        }
    },
    "optimization-viz-widget": {
        "type": "optimization-viz-widget",
        "icon": "fa-cog",
        "title": "Optimization Visualization",
        "config": {
            "title": "Optimization",
            "data3query": null,
            "height":490,
            "increment":96
        }
    },
    "maintenance-summary-widget": {
        "type": "maintenance-summary-widget",
        "icon": "fa-notes-medical",
        "title": "Maintenance Summary",
        "public":true,
        "config": {
            height:240,
        },
        "configInterface":{
            "title":"Maintenance Summary",
            "args":[
                {
                    "type":"string",
                    "name": "title",
                    "label":"Fixed title"
                },{
                    "type":"string",
                    "name": "title2",
                    "label":"Created title"
                },
                {
                    "type":"number",
                    "name": "height",
                    "label":"Height"
                }
            ]
        }
    },
    "issue-summary-widget": {
        "type": "issue-summary-widget",
        "icon": "fa-bell",
        "title": "Issue Summary",
        "config": {
            height:240,
        },
        "configInterface":{
            "title":"Issue Summary",
            "args":[
                {
                    "type":"string",
                    "name": "title",
                    "label":"Total issues title"
                },{
                    "type":"string",
                    "name": "title2",
                    "label":"New issues title"
                },{
                    "type":"string",
                    "name": "title3",
                    "label":"Acknowledged issues title"
                },
                {
                    "type":"number",
                    "name": "height",
                    "label":"Height"
                }
            ]
        }
    },
    "graphic-widget": {
        "type": "graphic-widget",
        "icon": "fa-cube",
        "title": "Graphic",
        "public":true,
        "config": {
        },
        "configInterface":{
            "title":"Graphic",
            "args":[
                {
                    "type":"graphic_selector",
                    "name": "graphic_id",
                    "label":"Graphic"
                },
                {
                    "type":"boolean",
                    "name": "menuMode",
                    "label":"Menu mode"
                },
                {
                    "type":"boolean",
                    "name": "inPageMenu",
                    "label":"Use as equipment selector",
                    "conditionField":"menuMode",
                    "conditionValue":true
                },
                {
                    "type":"boolean",
                    "name": "healthMode",
                    "label":"Equipment health mode"
                },
            ]
        }
    },
    "faults-report-widget": {
        "type": "faults-report-widget",
        "icon": "fa-bell",
        "title": "FDD Report",
        "public":true,
        "config": {
            "showSummary": true,
            "showAnomaly": false,
            "showFaults": true,
            "severityFilter":['critical','high','medium']
        },
        "configInterface":{
            "title":"FDD Report",
            "args":[
                {
                    "type":"boolean",
                    "name": "showSummary",
                    "label":"Show Summary"
                },{
                    "type":"boolean",
                    "name": "showFaults",
                    "label":"Show Faults"
                },{
                    "type":"boolean",
                    "name": "showAnomaly",
                    "label":"Show Anomaly"
                },
                {
                    "type":"selector",
                    "name": "severityFilter",
                    "label":"Severity",
                    "multiple":true,
                    "required":true,
                    "items":[
                        'info','low','medium','high','critical'
                    ]
                },
            ]
        }
    },
    "cost-breakdown-widget": {
        "type": "cost-breakdown-widget",
        "icon": "fa-dollar-sign",
        "title": "Cost Breakdown",
        "config": {
        },
        "configInterface":{
            "title":"Cost Breakdown",
            "args":[
                {
                    "type":"number",
                    "name": "height",
                    "label":"Height Override"
                },
                {
                    "type":"number",
                    "name": "leftmarg",
                    "label":"Left Margin Override"
                }
            ]
        }
    },
    "sensor-calibration-widget": {
        "type": "sensor-calibration-widget",
        "icon": "fa-cog",
        "title": "Sensor Calibration",
        "config": {
            title: "Sensor Calibration",
            conf:[],
        }
    },
    "tree-map-widget": {
        "type": "tree-map-widget",
        "icon": "fa-sitemap",
        "title": "Energy Breakdown",
        "config": {},
        "configInterface":{
            "title":"Energy Breakdown",
            "args":[
                {
                    "type":"string",
                    "name": "title",
                    "label":"Title"
                },
                {
                    "type":"string",
                    "name": "powerSensor",
                    "label":"Sensor"
                },{
                    "type":"agg_freq",
                    "name": "aggFrequency",
                    "label":"Aggregation Frequency"
                },
                {
                    "type":"string",
                    "name": "unit",
                    "label":"Unit"
                },
                {
                    "type":"number",
                    "name": "height",
                    "label":"Height"
                }
            ]
        }
    },
    "thermal-comfort-widget": {
        "type": "thermal-comfort-widget",
        "icon": "fa-thermometer-empty",
        "title": "Thermal Comfort",
        "config": {
            "title": "Thermal Comfort",
            "height":650,
            "dryBulbTemp": 25,
            // "radiantTemp":25,
            "relativeHumidity": 50,
            "airSpeed": 0.1,
            "metabolicRate": 1.2,
            "clothingLevel": 0.61,
        },
        "configInterface":{
            "title":"Thermal Comfort",
            "data3queryBuilder":true,
            "description":"<p>If a series in the query has the same name as one of the settings below then the last value in that series will be used instead of the provided setting.</p><p>Historical data can be overlaid in addition to current status if the query has data for dryBulbTemp and relativeHumidity.</p>",
            "args":[
                {
                    "type":"string",
                    "name": "title",
                    "label":"Title"
                },
                {
                    "type":"number",
                    "name": "height",
                    "label":"Height"
                },
                {
                    "type":"number",
                    "name": "dryBulbTemp",
                    "label":"Dry-bulb temperature | 10 < tdb[°C] < 40 | query name : dryBulbTemp"
                },
                {
                    "type":"number",
                    "name": "relativeHumidity",
                    "label":"Relative humidity | 0 < rh[%] < 100 | query name : relativeHumidity"
                },
                {
                    "type":"number",
                    "name": "airSpeed",
                    "label":"Air Speed | 0 < vr[m/s] < 2 | query name : airSpeed"
                },
                {
                    "type":"number",
                    "name": "metabolicRate",
                    "label":"Metabolic rate | 1 < met[met] < 4 | query name : metabolicRate"
                },
                {
                    "type":"number",
                    "name": "clothingLevel",
                    "label":"Clothing level | 0 < clo[clo] < 1.5 | query name : clothingLevel"
                },
            ]
        }
    },
    "solar-widget": {
        "type": "solar-widget",
        "icon": "fa-sun",
        "title": "Solar",
        "config": {
            "height": 500,
            "showClock": false,
            "mainIntensity": 6,
            "ambientIntensity": 0,
            "featuresJson":""
        }
    },
    "parameter-widget": {
        "type": "parameter-widget",
        "icon": "fa-sliders-h",
        "title": "Parameters",
        "config": {
            "fields":[]
        }
    },
    "autotuner-widget": {
        "type": "autotuner-widget",
        "icon": "fa-wrench",
        "title": "Autotuner",
        "config": {
            "height": 300,
        },
        "configInterface":{
            "title":"Autotuner",
            "args":[
                {
                    "type":"string",
                    "name": "title",
                    "label":"Title"
                },
                {
                    "type":"autotuner_selector",
                    "name": "autotunerId",
                    "label":"Autotuner"
                },
                {
                    "type":"number",
                    "name": "height",
                    "label":"Height"
                }
            ]
        }
    },
    "optimization-control-widget": {
        "type": "optimization-control-widget",
        "icon": "fa-cog",
        "title": "Optimization Control",
        "config": {
            "colWidth": 12,
            "equipmentColWidth":12
        },
        "configInterface":{
            "title":"Optimization Control",
            "args":[
                {
                    "type":"equipment_name",
                    "name": "defaultEquipment",
                    "label":"Default Equipment"
                },
                {
                    "type":"boolean",
                    "name": "followEquipment",
                    "label":"Follow Equipment Selector"
                },
                {
                    "type":"boolean",
                    "name": "useRelationship",
                    "label":"Get Equipments by Ref"
                },
                {
                    "type":"string",
                    "name": "relationshipType",
                    "label":"Ref Type",
                    "conditionField":"useRelationship",
                    "conditionValue":true
                },{
                    "type":"string",
                    "name": "specificSensors",
                    "label":"Specfic Sensors (comma separated)",
                },
                {
                    "type":"number",
                    "name": "colWidth",
                    "label":"Column Width"
                },{
                    "type":"number",
                    "name": "equipmentColWidth",
                    "label":"Equipment Column Width"
                },
                {
                    "type":"boolean",
                    "name": "showPriorities",
                    "label":"Show Writing Priority Array"
                }
            ]
        }
    },
    "clock-control-widget": {
        "type": "clock-control-widget",
        "icon": "fa-clock",
        "title": "Time Control",
        "config": {
            "target":"end",
            "title":"Time",
            "animateMode":false,
            "frameDuration":5000,
            "frameMultiplier": 1,
            "loop":false
        },
        "configInterface":{
            "title":"Time Control",
            "args":[
                {
                    "type":"string",
                    "name": "title",
                    "label":"Title"
                },
                {
                    "type":"selector",
                    "name": "target",
                    "label":"Date Range Target",
                    "multiple":false,
                    "required":true,
                    "items":[
                        'start','end'
                    ]
                },
                {
                    "type":"boolean",
                    "name": "animateMode",
                    "label":"Animate"
                },
                {
                    "type":"boolean",
                    "name": "loop",
                    "label":"Loop",
                    "conditionField":"animateMode",
                    "conditionValue":true
                },
                {
                    "type":"number",
                    "name": "frameDuration",
                    "label":"Frame Duration (ms)",
                    "conditionField":"animateMode",
                    "conditionValue":true
                },
                {
                    "type":"number",
                    "name": "frameMultiplier",
                    "label":"Frame Multiplier",
                    "conditionField":"animateMode",
                    "conditionValue":true
                },
            ]
        }
    },
}